export enum QuestionType {
  SYSTEM = 0,
  DROPDOWN = 1,
  TEXT = 2,
  LICENCE = 3,
  CHECKBOX = 4,
  DATE_PICKER = 5,
  NUMBER = 6,
  FILE_UPLOAD = 8,
  CONTENT = 9,
}
